var React = require('react');

function LuxuryIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M162.209 87.563h-36.582l13.296-35.985 23.286 35.984Zm-43.585 4.874-22.623 61.219L73.38 92.437h45.245Zm-44.955-4.874L96 53.05l22.333 34.513H73.669ZM100.48 51h33.457l-12.163 32.906L100.481 51ZM70.228 83.906 58.064 51h33.457L70.228 83.906Zm19.628 67.186L31.198 92.436H68.18l21.676 58.656Zm33.967-58.656h36.982l-58.659 58.659 21.677-58.659ZM53.079 51.577l13.297 35.984H29.794l23.285-35.984Zm67.296-22.59c.71.956 1.557 1.803 2.513 2.513a12.162 12.162 0 0 0-2.513 2.513 12.16 12.16 0 0 0-2.513-2.513 12.165 12.165 0 0 0 2.513-2.513Zm34.125 8.394a17.201 17.201 0 0 0-5.881-5.881 17.202 17.202 0 0 0 5.881-5.882 17.2 17.2 0 0 0 5.881 5.882 17.203 17.203 0 0 0-5.881 5.881Z"}));
}

LuxuryIconInline.defaultProps = {"className":"fill-current","viewBox":"0 0 200 155"};

module.exports = LuxuryIconInline;

LuxuryIconInline.default = LuxuryIconInline;
